import { useState, useRef } from 'react'
import { searchByUsername } from '../services/api'

// vue-multiselect replica — same idle/typing/suggestions DOM as the reference
// site (used on Account Statement, User History, General Lock, ...)
function ClientMultiselect({ value, onChange, onSelect, placeholder = 'Select option', showNoResults = true }) {
  const [open, setOpen] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const [highlightIdx, setHighlightIdx] = useState(0)
  const inputRef = useRef(null)
  const timerRef = useRef(null)

  const handleChange = (val) => {
    onChange(val)
    if (timerRef.current) clearTimeout(timerRef.current)
    if (val.length >= 2) {
      timerRef.current = setTimeout(async () => {
        try {
          const res = await searchByUsername(val, 1, 15)
          const results = res?.data?.results || res?.data || []
          setSuggestions(results)
          setHighlightIdx(0)
        } catch {
          setSuggestions([])
        }
      }, 300)
    } else {
      setSuggestions([])
    }
  }

  return (
    <div
      tabIndex="-1"
      role="combobox"
      aria-owns="listbox-null"
      className={`multiselect${open ? ' multiselect--active' : ''}`}
      onMouseDown={(e) => {
        // option clicks handle themselves; avoid the blur/focus flicker cycle
        if (e.target.closest('.multiselect__content-wrapper')) return
        if (e.target !== inputRef.current) {
          e.preventDefault()
          inputRef.current?.focus()
          setOpen(true)
        }
      }}
    >
      <div className="multiselect__select"></div>
      {'  '}
      <div className="multiselect__tags">
        <div className="multiselect__tags-wrap" style={{ display: 'none' }}></div>
        {' '}
        <div className="multiselect__spinner" style={{ display: 'none' }}></div>
        {' '}
        <input
          ref={inputRef}
          name=""
          type="text"
          autoComplete="off"
          spellCheck="false"
          placeholder={placeholder}
          tabIndex="0"
          aria-controls="listbox-null"
          className="multiselect__input"
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 200)}
          style={open ? { width: '100%' } : { width: '0px', position: 'absolute', padding: '0px' }}
        />
        {' '}
        {!open && !value && (
          <span className="multiselect__placeholder">{`\n          ${placeholder}\n        `}</span>
        )}
        {!open && value ? <span className="multiselect__single">{value}</span> : null}
      </div>
      {' '}
      <div tabIndex="-1" className="multiselect__content-wrapper" style={{ maxHeight: '300px', display: open ? 'block' : 'none' }}>
        <ul role="listbox" id="listbox-null" className="multiselect__content" style={{ display: suggestions.length ? 'inline-block' : 'block' }}>
          {' '}
          {suggestions.map((u, i) => (
            <li
              key={u.wallet_id || u.user_id || u.staff_id || u.username}
              id={`null-${i}`}
              role="option"
              className="multiselect__element"
              onMouseDown={(e) => {
                e.preventDefault()
                onSelect(u)
                setOpen(false)
                setSuggestions([])
              }}
            >
              <span
                className={`multiselect__option${i === highlightIdx ? ' multiselect__option--highlight' : ''}`}
                onMouseEnter={() => setHighlightIdx(i)}
              >{u.username}</span>
            </li>
          ))}
          {/* vue-multiselect keeps both status rows in the DOM (v-show) */}
          <li style={showNoResults && !suggestions.length && value ? {} : { display: 'none' }}><span className="multiselect__option">No elements found. Consider changing the search query.</span></li>
          {' '}
          <li style={!suggestions.length && (!value || !showNoResults) ? {} : { display: 'none' }}><span className="multiselect__option">List is empty.</span></li>
          {' '}
        </ul>
      </div>
    </div>
  )
}

export default ClientMultiselect
